import { useEffect } from "react";
import { useSelector } from "react-redux";
import { translate } from "game/translate";
import { Popups, KingPopupData } from "ui/types/popups";
import { UIRootState } from "ui/store/reducers";
import "./styles.css";
import { GameUI } from "game/gameUI/GameUI";

addEventListener('showKingPopup', () => {
    GameUI.showPopup(Popups.KING_POPUP, { textKey: 'king_popup_text', isNotification: true });
});

export const KingPopup = () => {
    const kingPopup = useSelector((state: UIRootState) => state.popups?.[Popups.KING_POPUP]);
    const data = kingPopup?.data as KingPopupData | undefined;
    const textKey = data?.textKey || "";

    useEffect(() => {
        if (kingPopup?.isOpen) {
            const timer = setTimeout(() => {
                GameUI.closePopup(Popups.KING_POPUP);
            }, 5500);

            return () => clearTimeout(timer);
        }
    }, [kingPopup?.isOpen]);

    if (!kingPopup?.isOpen) return null;

    return (
        <div className="king-popup-container">
            <div className="king-popup-king">
                <picture>
                    <source srcSet="/assets/kingPopup/king.webp" type="image/webp" />
                    <img src="/assets/kingPopup/king.png" alt="King" className="king-popup-king-image" />
                </picture>
                <div className="king-popup-cloud">
                    <svg className="king-popup-triangle" xmlns="http://www.w3.org/2000/svg" width="36" height="32" viewBox="0 0 36 32" fill="none">
                        <path d="M35.1144 17.1425L23.224 7.30543e-08L22.6164 2.67064C19.8362 14.891 11.6619 25.194 0.39077 30.6846C-0.270302 31.0066 -0.0414156 32.0003 0.693826 32.0003L3.37727 32.0003C15.6356 32.0002 27.2631 26.5567 35.1144 17.1425Z" fill="#F3F3E9"/>
                    </svg>
                    <span className="king-popup-text">
                        {translate(textKey)}
                    </span>
                </div>
            </div>
        </div>
    );
};

